// 企业管理模块多语言配置
export const business = {
  'zh-CN': {
    // 企业管理
    enterpriseMember: '企业成员',
    memberDetail: '成员详情',
    administratorList: '管理员列表',
    sectorSetup: '部门设置',
    setBanner: '设置横幅',
    assessmentDetails: '考核详情',
    inspectionRules: '检查规则',
    websiteSettings: '网站设置',
    formDetail: '表单详情',
    performanceAssessment: '绩效考核',
    publishAdvancedForm: '发布高级表单',
    corporateInformation: '企业信息',
    appointmentManagement: '预约管理',
    advancedForm: '高级表单',
    advertisingManagement: '广告管理',
    wechatClient: '微信客户端',
    
    // 管理员列表相关
    searchAdministratorName: '搜索管理员姓名',
    addAdministrator: '新增管理员',
    changeBoss: '更换BOSS',
    responsibleDepartment: '负责部门',
    permissions: '权限',
    clickToView: '点击查看',
    viewPermissions: '查看权限',
    identityVerification: '身份验证',
    verify: '验证',
    employeeList: '员工列表',
    searchEmployeeName: '搜索员工姓名',
    noEmployees: '暂无员工',
    noPermissionsAssigned: '暂无权限分配',
    deleteConfirm: '确定删除该管理员？',
    changeBossConfirm: '确定更换BOSS吗？',
    selectEmployee: '请选择员工',
    changeSuccess: '更换成功',
    tip: '提示',
    
    // 成员管理
    memberName: '成员姓名',
    memberPhone: '成员电话',
    memberEmail: '成员邮箱',
    memberRole: '成员角色',
    memberStatus: '成员状态',
    joinDate: '加入日期',
    department: '部门',
    position: '职位',
    jobNumber: '工号',
    createTime: '创建时间',
    loginAccount: '登录账号',
    
    // 设置流程说明
    setupProcess: '设置部门和管理员流程:①请先在下方成员列表中选择相应员工,点击"编辑",设置为管理员------②在"部门设置"中,新增部门,选择相应管理员------③如需设置管理员相关权限,可在"管理员列表"里编辑修改管理员权限',
    
    // 编辑成员对话框
    editMember: '编辑成员',
    name: '姓名',
    displayPhone: '名片展示手机号',
    displayEmail: '名片展示邮箱',
    loginEmail: '登录邮箱',
    setMemberRole: '设置成员角色',
    normalMember: '普通成员',
    administrator: '管理员',
    pleaseSelect: '请选择',
    
    // 企业微信授权
    wechatAuth: '企业微信授权',
    wechatAuthTip: '请使用与BOSS账号为同一微信主体的企业微信超级管理员账号扫码授权。',
    wechatAuthNote: '注：只有BOSS授权后，企业下成员才可进行授权。',
    wechatAuthorized: '企业微信已授权',
    
    // 权限相关消息
    noPermission: '暂无权限',
    bossInfoCannotModify: 'BOSS信息无法修改',
    
    // 角色类型
    employee: '员工',
    administrator: '管理员',
    boss: 'BOSS',
    
    // 考核管理
    assessmentName: '考核名称',
    assessmentType: '考核类型',
    assessmentDate: '考核日期',
    assessmentScore: '考核分数',
    assessmentResult: '考核结果',
    assessmentRemark: '考核备注',
    
    // 成员考核页面
    assessmentRules: '考核规则',
    assessmentObject: '考核对象',
    assessmentContent: '考核内容',
    assessmentTimeCycle: '考核时间周期',
    assessmentStatus: '状态',
    assessmentPassRate: '考核达标率',
    assessmentOperation: '操作',
    assessmentDetail: '详情',
    assessmentRevoke: '撤销',
    assessmentAdd: '新增考核规则',
    assessmentEdit: '编辑',
    assessmentQuery: '查询',
    assessmentAll: '全部',
    assessmentNotStarted: '未开始',
    assessmentInProgress: '进行中',
    assessmentEnded: '已结束',
    assessmentConfirmRevoke: '确定撤销此考核规则吗？删除后不可恢复！',
    assessmentRevokeSuccess: '成功撤销！',
    assessmentCancelInput: '取消输入',
    assessmentRulesName: '考核规则名称',
    assessmentRulesPlaceholder: '考核规则/考核对象名称',
    assessmentStatusPlaceholder: '请选择状态',
    assessmentStartDate: '开始日期',
    assessmentEndDate: '结束日期',
    assessmentAddCustomer: '添加客户数',
    assessmentNewVisitors: '新用户访客数',
    assessmentFollowUpRate: '跟进客户率',
    assessmentSalesAmount: '商城销售金额',
    assessmentPeople: '人',
    selectAssessmentObject: '选择考核对象',
    
    // 表单管理
    formName: '表单名称',
    formType: '表单类型',
    formStatus: '表单状态',
    createForm: '创建表单',
    editForm: '编辑表单',
    publishForm: '发布表单',
    formTemplate: '表单模板',
    
    // 高级表单页面
    formList: '表单列表',
    basicSettings: '基础设置',
    publishForm: '发布表单',
    query: '查询',
    startDate: '开始日期',
    endDate: '结束日期',
    publishTime: '发布时间',
    endTime: '结束时间',
    feedbackCount: '反馈人数',
    operation: '操作',
    feedbackDetail: '反馈详情',
    edit: '编辑',
    online: '上架',
    offline: '下架',
    formModuleName: '表单模块名称',
    formIntroduction: '表单介绍语',
    buttonName: '按钮名称',
    contactUs: '联系我们',
    submitFeedback: '提交反馈',
    feedbackPlaceholder: '若您对我们有更好的建议或意见,您可以点击下方提交反馈,提出您宝贵的建议,感谢你的支持,我们收到后将第一时间与您联系！',
    saveSettings: '保存设置',
    completeSettings: '请完整填写基础设置',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    noPermission: '暂无权限',
    operationSuccess: '操作成功！',
    cancelInput: '取消输入',
    cancelReason: '请输入取消理由',
    confirm: '确定',
    cancel: '取消',
    publishFormConfirm: '此表单将会作为一个新的表单发布，其用户历史记录不会跟随移动。',
    offlineFormConfirm: '点击则下架此表单,并显示结束时间。并且用户端的"高级表单"页面将无内容显示？',
    
    // 广告图管理页面
    imagePosition: '图片位置',
    imageCount: '图片数量',
    mallSection: '商城版块',
    appointmentSection: '预约版塊',
    dynamicSection: '動態版塊',
    selectAuditDemand: '請選擇審核中的需求',
    uploadTip: '上傳圖片的最佳尺寸：690*300像素，其他尺寸會影響頁面效果，格式png，jpeg，jpg。大小不超過2M，最少上傳1張最多可上傳6張',
    save: '保存',
    uploading: '正在上傳',
    uploadSuccess: '上傳成功',
    uploadFailed: '上傳失敗，請重試',
    settingSuccess: '設置成功',
    categorySortTip: '請輸入排序數字，數字越小排序越靠前',
    
    // 企业信息管理
    companyLogo: '企業LOGO',
    companyName: '企業名稱',
    industry: '所屬行業',
    companyPassword: '企業密令',
    companyNotice: '企業公告',
    uploadImage: '上傳圖片',
    pleaseEnter: '請輸入',
    pleaseSelect: '請選擇',
    passwordPlaceholder: '其他人加入企業需此密令',
    pleaseUploadLogo: '請上傳logo',
    pleaseEnterCompanyName: '請輸入企業名稱',
    pleaseSelectIndustry: '請選擇所屬行業',
    pleaseEnterCompanyPassword: '請輸入企業密令',
    uploading: '正在上傳',
    uploadSuccess: '上傳成功',
    saveSuccess: '保存成功',

    // 预约管理相关
    publishProduct: '发布商品',
    pleaseSelect: '请选择',
    all: '全部',
    query: '查询',
    productId: '产品ID',
    productName: '产品名称',
    category: '分类',
    price: '价格',
    orderTime: '下单时间',
    appointmentTime: '预约时间',
    operation: '操作',
    edit: '编辑',
    delete: '删除',
    confirmDeleteProduct: '确定删除该商品？',
    sort: '排序',
    userName: '用户姓名',
    appointmentPhone: '预约电话',
    remark: '备注',
    status: '状态',
    cancelAppointment: '取消预约',
    confirmAppointment: '确认预约',
    newCategory: '新建分类',
    categoryName: '分类名称',
    pleaseEnterCategoryName: '请输入分类名称',
    categoryId: '分类ID',
    productCount: '商品数量',
    addCategory: '新增分类',
    editCategory: '编辑分类',
    deleteCategory: '删除分类',
    confirmDeleteCategory: '此操作将永久删除该分类, 是否继续?',
    operationSuccess: '操作成功',
    cancelInput: '取消输入',
    selectProductCategory: '1.选择产品分类',
    productCategory: '产品分类',
    inputProductBasicInfo: '2.输入产品基本信息',
    productTitle: '产品标题',
    pleaseEnterContent: '请输入内容',
    productPrice: '产品价格',
    specificAmount: '具体金额',
    rangeAmount: '区间金额',
    suchAs: '如：',
    productDescription: '产品简述',
    productImage: '商品图片',
    uploadImageTip: '上传图片的最佳尺寸：800像素*800像素，其他尺寸会影响页效果，格式png，jpeg，jpg。大小不超过2M，商品图片一共可以上传5张，默认第一张为主图封面',
    shareImage: '分享图片',
    shareImageTip: '上传图片及支持png/jpg 。显示图片长宽比为5:4',
    shareImageUsage: '用于小程序分享时展示图片',
    serviceMethod: '3.服务方式',
    serviceType: '服务方式',
    inStore: '到店',
    doorToDoor: '上门',
    inputProductDetails: '4.输入产品详情',
    publish: '发布',
    pleaseSelectCategory: '请选择分类！',
    pleaseEnterProductTitle: '请输入产品标题！',
    pleaseEnterSpecificAmount: '请输入具体金额',
    pleaseEnterRangeAmount: '请输入区间金额!',
    pleaseEnterDescription: '请输入描述',
    pleaseUploadProductImage: '请上传商品图片',
    pleaseUploadShareImage: '请上传分享图片',
    pleaseSelectServiceMethod: '请选择服务方式！',
    uploading: '正在上传',
    uploadSuccess: '上传成功',
    pleaseEnterCancelReason: '请输入取消理由',
    prompt: '提示',
    confirm: '确定',
    cancel: '取消',
    confirmAcceptAppointment: '确定接受此次预约么?',
    operationSuccessExclamation: '操作成功！',
    pleaseEnterCancelReason: '请输入取消理由',
    selectDate: '选择日期',
    pendingConfirmation: '待确认',
    confirmed: '已确认',
    completed: '已完成',
    cancelled: '已取消',
    expired: '已过期',
    
    // 客户管理相关
    moveToMember: '移至成员',
    moveToShared: '移至共享',
    pleaseEnterPhoneNameWechat: '请输入电话、姓名或微信号',
    search: '查询',
    export: '导出',
    serialNumber: '序号',
    name: '姓名',
    phoneNumber: '手机号码',
    wechatAccount: '微信号',
    createTime: '创建时间',
    remarks: '备注',
    transfer: '移交',
    details: '详情',
    customerWechatData: '客户企微数据',
    contactCustomerStatistics: '联系客户统计',
    chatDataAnalysis: '聊天数据分析',
    moveToMemberTitle: '移至成员',
    moveToSharedTitle: '移至共享',
    pleaseSelectTransferMember: '请先选择移交的成员',
    transferSuccess: '移交成功',
    moveToSharedConfirm: '此操作会将客户移至共享池',
    prompt: '提示',
    confirm: '确定',
    cancel: '取消',
    warning: '警告',
    
    // 日期相关
    startDate: '开始日期',
    endDate: '结束日期',
    yesterday: '昨日',
    last7Days: '近七日',
    last30Days: '近30日',
    
    // 企微聊天统计相关
    customerWechatChatStatistics: '与客户企微聊天统计',
    maxQuerySpan30Days: '支持的最大查询跨度为30天',
    maxQuerySpan180Days: '最多可获取最近180天内的数据',
    
    // 企微数据统计项
    newApplyCount: '发起申请数',
    newApplyCountDesc: '成员通过「搜索手机号」、「扫一扫」、「从微信好友中添加」、「从群聊中添加」、「添加共享、分配给我的客户」、「添加单向、双向删除好友关系的好友」、「从新的联系人推荐中添加」等渠道主动向客户发起的好友申请数量',
    newContactCount: '新增客户数',
    newContactCountDesc: '新添加的客户数量',
    chatCount: '聊天总数',
    chatCountDesc: '主动发送过消息的单聊总数',
    messageCount: '发送消息数',
    messageCountDesc: '单聊中发送的消息总数',
    replyPercentage: '已回复聊天占比',
    replyPercentageDesc: '客户主动发起聊天后，成员在一个自然日内有回复过消息的聊天数/客户主动发起的聊天数比例，不包括群聊，仅在确有聊天时返回',
    avgReplyTime: '平均首次回复时长',
    avgReplyTimeDesc: '单位为分钟，即客户主动发起聊天后，成员在一个自然日内首次回复的时长间隔为首次回复时长，所有聊天的首次回复总时长/已回复的聊天总数即为平均首次回复时长，不包括群聊，仅在确有聊天时返回',
    negativeFeedbackCount: '删除/拉黑成员的客户数',
    negativeFeedbackCountDesc: '将成员删除或加入黑名单的客户数',
    
    // 预约管理标签页
    appointmentList: '预约列表',
    goodsList: '商品列表',
    productCategory: '产品分类',
    
    // 表单详情相关
    pleaseSelect: '请选择',
    startDate: '开始日期',
    endDate: '结束日期',
    to: '至',
    query: '查询',
    export: '导出',
    serialNumber: '序号',
    userName: '用户名',
    createTime: '创建时间',
    all: '全部',
    userFeedback: '用户反馈',
    
    // 成员详情相关
    basicInfo: '基本信息',
    name: '姓名',
    phoneNumber: '手机号码',
    wechatAccount: '微信号',
    position: '职位',
    exclusiveCustomerCount: '独占客户数',
    dealCustomerCount: '成单客户数',
    wechatCustomerCount: '企微客户数',
    operation: '操作',
    delete: '删除',
    exclusiveCustomer: '独占客户',
    dealCustomer: '成单客户',
    wechatCustomer: '企微客户',
    deleteMemberConfirm: '是否删除该成员?',
    prompt: '提示',
    confirm: '确定',
    cancel: '取消',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    selectName: "请选择",
    noDepartment: "没有部门",
    goToSettings: '去设置',
    addDepartment: '新增部门',

    // 部门设置
    sectorSetup: '部门设置',
    departmentName: '部门名称',
    administrator: '管理员',
    departmentMemberCount: '部门人数',
    authorizedMembers: '已授权成员',
    pendingAuthorizedMembers: '待授权成员数',
    operation: '操作',
    edit: '编辑',
    dissolve: '解散',
    searchDepartment: '请输入部门名称/管理员姓名',
    search: '搜索',
    importQywxStructure: '导入企微组织架构',
    viewAll: '查看所有',
    viewAllMembers: '查看所有成员',
    totalMembers: '共 {count} 位成员',
    departmentMemberList: '部门成员列表',
    departmentAdministrator: '部门管理员',
    modify: '修改',
    add: '新增',
    departmentEmployeeList: '部门员工列表',
    selectAll: '全选',
    addMember: '新增',
    remove: '移除',
    save: '保存',
    administratorList: '管理员列表',
    searchAdministrator: '请输入管理员姓名',
    noAdministrator: '暂无管理员',
    confirm: '确认',
    memberList: '成员列表',
    searchMember: '请输入成员姓名',
    importQywxStructureTitle: '导入企业微信组织架构',
    qywxInfoNotFilled: '未填写企微信息的账号并授权好，系统将无法导入。',
    goToFill: '去填写',
    goToAuthorize: '去授权',
    importWarning: '导入企业微信组织架构后，原组织架构将会被替代，所有原部门数据将会被清除，请慎重操作。',
    cancel: '取消',
    importConfirm: '确认',
    pleaseEnterDepartmentName: '请输入部门名称',
    addSuccess: '添加成功',
    operationCancelled: '操作取消',
    confirmDissolve: '是否确认解散该分组，解散后不可恢复。',
    tip: '提示',
    saveSuccess: '保存成功',
    pleaseAuthorizeQywx: '请先授权企业微信',
    operationSuccess: '操作成功',
    operationFailed: '操作失败，请稍后重试',
    pleaseSelectAdministrator: '请选择管理员',

    // 考核详情相关
    assessmentRuleName: '考核规则名称',
    assessmentTimeCycle: '考核时间周期',
    assessmentStatus: '考核状态',
    assessmentContent: '考核内容',
    assessmentPassRate: '考核达标率',
    assessmentSituation: '考核情况',
    assessmentSituationTip: '可通过输入或选择考核对象名称查看相应成员的考核详情。',
    addCustomerCount: '添加客户数',
    newUserVisitCount: '新用户访问数',
    customerFollowUpRate: '客户跟进率',
    mallSalesAmount: '商城销售金额',
    unit: '个',
    yuan: '港元',
    percent: '%',
    percentage: '%',
    inProgress: '进行中',
    notStarted: '未开始',
    ended: '已结束',
    pleaseSelectEmployee: '请选择员工',
    search: '搜索',
    note: '注：默认只展示排名前三位员工的数据，其他成员请搜索查询',
    completed: '已完成',
    selectRules: '选择规则',
    noData: '暂无数据',
    selectAll: '全选',
    pleaseSelectDepartment: '请选择部门',
    pleaseSelectDepartmentFirst: '请先选择部门',
    pleaseEnterEmployeeName: '请输入员工姓名',
    newUserVisitorCount: '新用户访问数',
    
    // 微信客户端相关
    customerWechatData: '客户企微数据',
    wechatChatStatistics: '与客户企微聊天统计',
    singleChatTotal: '单聊总数',
    sendMessageCount: '发送消息数',
    sendRedPacketCount: '发送红包数',
    sendRedPacketAmount: '发送红包金额',
    repliedChatPercentage: '已回复聊天占比',
    averageFirstReplyTime: '平均首次回复时长',
    mallOrder: '商城订单',
    enterprise: '企业',
    description: '描述',
    source: '来源',
    warning: '警告',
    pleaseSelectTransferMember: '请先选择移交的成员',
    transferSuccess: '移交成功',
    moveToMemberTitle: '移至成员',
    formTitle: "表单标题",
    formContent: "表单内容",
    title: "标题",
    isRequired: "是否必填",
    content: "内容",
    on: "是",
    off: "否",
    add: "新增",
    addSingle:"增加单行",
    singleOption: "单行选项",
    multipleOption: "多行选项",
    dropdownOption: "下拉选项",
    textBox: "文本框",
    rating: "评分",
    imageUpload: "图片上传",
    addressLocation: "地址定位",
    personalInfo: "个人信息",
    dateSelection: "日期选择",
    addMultiple: "增加多行",
    addSingleRating: "增加单行评分",
    addSingleDropdown: "增加单行下拉",
    addSingleText: "增加单行文本",
    pleaseEnterText: "请输入文本",
    clickToUploadImage: "点击上传图片",
    image: "图片",
    addSingleTitleContent: "增加单行标题和内容",
    selectStartDate: "选择开始日期",
    selectEndDate: "选择结束日期",
    pleaseEnterTitle: "请输入标题",
    
    // 管理员列表相关
    searchAdministratorName: '搜索管理员姓名',
    addAdministrator: '新增管理员',
    changeBoss: '更换BOSS',
    responsibleDepartment: '负责部门',
    permissions: '权限',
    clickToView: '点击查看',
    viewPermissions: '查看权限',
    identityVerification: '身份验证',
    verify: '验证',
    employeeList: '员工列表',
    searchEmployeeName: '搜索员工姓名',
    noEmployees: '暂无员工',
    noPermissionsAssigned: '暂无权限分配',
    deleteConfirm: '确定删除该管理员？',
    changeBossConfirm: '确定更换BOSS吗？',
    selectEmployee: '请选择员工',
    changeSuccess: '更换成功',
    tip: '提示',
    noPermissionsSelected: '暂无权限选择',
    permissionsSelected: '已选择权限',

    addEmployee: '新增员工',
    employeeName: '员工姓名',
    employeeEmail: '员工邮箱',
    employeePhone: '员工电话',
    departmentName: '部门名称',
    pleaseEnterEmployeeName: '请输入员工姓名',
    pleaseEnterEmployeeEmail: '请输入员工邮箱',
    pleaseEnterEmployeePhone: '请输入员工电话',
    pleaseEnterDepartmentName: '请输入部门名称',
    pleaseEnterPosition: '请输入职位',
    pleaseEnterValidEmail: '请输入有效的邮箱地址',
    addEmployeeSuccess: '新增员工成功',
    addEmployeeFailed: '新增员工失败',
  },
  'zh-TW': {
    // 企業管理
    enterpriseMember: '企業成員',
    memberDetail: '成員詳情',
    administratorList: '管理員列表',
    sectorSetup: '部門設置',
    setBanner: '設置橫幅',
    assessmentDetails: '考核詳情',
    inspectionRules: '檢查規則',
    websiteSettings: '網站設置',
    formDetail: '表單詳情',
    performanceAssessment: '績效考核',
    publishAdvancedForm: '發布高級表單',
    corporateInformation: '企業信息',
    appointmentManagement: '預約管理',
    advancedForm: '高級表單',
    advertisingManagement: '廣告管理',
    wechatClient: '微信客户端',
    
    // 成員管理
    memberName: '成員姓名',
    memberPhone: '成員電話',
    memberEmail: '成員郵箱',
    memberRole: '成員角色',
    memberStatus: '成員狀態',
    joinDate: '加入日期',
    department: '部門',
    position: '職位',
    jobNumber: '工號',
    createTime: '創建時間',
    loginAccount: '登錄賬號',
    
    // 設置流程說明
    setupProcess: '設置部門和管理員流程:①請先在下方成員列表中選擇相應員工,點擊"編輯",設置為管理員------②在"部門設置"中,新增部門,選擇相應管理員------③如需設置管理員相關權限,可在"管理員列表"裡編輯修改管理員權限',
    
    // 編輯成員對話框
    editMember: '編輯成員',
    name: '姓名',
    displayPhone: '名片展示手機號',
    displayEmail: '名片展示郵箱',
    loginEmail: '登錄郵箱',
    setMemberRole: '設置成員角色',
    normalMember: '普通成員',
    administrator: '管理員',
    pleaseSelect: '請選擇',
    
    // 企業微信授權
    wechatAuth: '企業微信授權',
    wechatAuthTip: '請使用與BOSS賬號為同一微信主體的企業微信超級管理員賬號掃碼授權。',
    wechatAuthNote: '注：只有BOSS授權後，企業下成員才可進行授權。',
    wechatAuthorized: '企業微信已授權',
    
    // 權限相關消息
    noPermission: '暫無權限',
    bossInfoCannotModify: 'BOSS信息無法修改',
    
    // 角色類型
    employee: '員工',
    administrator: '管理員',
    boss: 'BOSS',
    
    // 考核管理
    assessmentName: '考核名稱',
    assessmentType: '考核類型',
    assessmentDate: '考核日期',
    assessmentScore: '考核分數',
    assessmentResult: '考核結果',
    assessmentRemark: '考核備註',
    
    // 成員考核頁面
    assessmentRules: '考核規則',
    assessmentObject: '考核對象',
    assessmentContent: '考核內容',
    assessmentTimeCycle: '考核時間週期',
    assessmentStatus: '狀態',
    assessmentPassRate: '考核達標率',
    assessmentOperation: '操作',
    assessmentDetail: '詳情',
    assessmentRevoke: '撤銷',
    assessmentAdd: '新增考核規則',
    assessmentEdit: '編輯',
    assessmentQuery: '查詢',
    assessmentAll: '全部',
    assessmentNotStarted: '未開始',
    assessmentInProgress: '進行中',
    assessmentEnded: '已結束',
    assessmentConfirmRevoke: '確定撤銷此考核規則嗎？刪除後不可恢復！',
    assessmentRevokeSuccess: '成功撤銷！',
    assessmentCancelInput: '取消輸入',
    assessmentRulesName: '考核規則名稱',
    assessmentRulesPlaceholder: '考核規則/考核對象名稱',
    assessmentStatusPlaceholder: '請選擇狀態',
    assessmentStartDate: '開始日期',
    assessmentEndDate: '結束日期',
    assessmentAddCustomer: '添加客戶數',
    assessmentNewVisitors: '新用戶訪客數',
    assessmentFollowUpRate: '跟進客戶率',
    assessmentSalesAmount: '商城銷售金額',
    assessmentPeople: '人',
    selectAssessmentObject: '選擇考核對象',
    
    // 表單管理
    formName: '表單名稱',
    formType: '表單類型',
    formStatus: '表單狀態',
    createForm: '創建表單',
    editForm: '編輯表單',
    publishForm: '發布表單',
    formTemplate: '表單模板',
    
    // 高級表單頁面
    formList: '表單列表',
    basicSettings: '基礎設置',
    publishForm: '發布表單',
    query: '查詢',
    startDate: '開始日期',
    endDate: '結束日期',
    publishTime: '發布時間',
    endTime: '結束時間',
    feedbackCount: '反饋人數',
    operation: '操作',
    feedbackDetail: '反饋詳情',
    edit: '編輯',
    online: '上架',
    offline: '下架',
    formModuleName: '表單模塊名稱',
    formIntroduction: '表單介紹語',
    buttonName: '按鈕名稱',
    contactUs: '聯繫我們',
    submitFeedback: '提交反饋',
    feedbackPlaceholder: '若您對我們有更好的建議或意見,您可以點擊下方提交反饋,提出您寶貴的建議,感謝你的支持,我們收到後將第一時間與您聯繫！',
    saveSettings: '保存設置',
    completeSettings: '請完整填寫基礎設置',
    saveSuccess: '保存成功',
    saveFailed: '保存失敗',
    noPermission: '暫無權限',
    operationSuccess: '操作成功！',
    cancelInput: '取消輸入',
    cancelReason: '請輸入取消理由',
    confirm: '確定',
    cancel: '取消',
    publishFormConfirm: '此表單將會作為一個新的表單發布，其用戶歷史記錄不會跟隨移動。',
    offlineFormConfirm: '點擊則下架此表單,並顯示結束時間。並且用戶端的"高級表單"頁面將無內容顯示？',
    
    // 廣告圖管理頁面
    imagePosition: '圖片位置',
    imageCount: '圖片數量',
    mallSection: '商城版塊',
    appointmentSection: '預約版塊',
    dynamicSection: '動態版塊',
    selectAuditDemand: '請選擇審核中的需求',
    uploadTip: '上傳圖片的最佳尺寸：690*300像素，其他尺寸會影響頁面效果，格式png，jpeg，jpg。大小不超過2M，最少上傳1張最多可上傳6張',
    save: '保存',
    uploading: '正在上傳',
    uploadSuccess: '上傳成功',
    uploadFailed: '上傳失敗，請重試',
    settingSuccess: '設置成功',
    categorySortTip: '請輸入排序數字，數字越小排序越靠前',
    
    // 企业信息管理
    companyLogo: '企業LOGO',
    companyName: '企業名稱',
    industry: '所屬行業',
    companyPassword: '企業密令',
    companyNotice: '企業公告',
    uploadImage: '上傳圖片',
    pleaseEnter: '請輸入',
    pleaseSelect: '請選擇',
    passwordPlaceholder: '其他人加入企業需此密令',
    pleaseUploadLogo: '請上傳logo',
    pleaseEnterCompanyName: '請輸入企業名稱',
    pleaseSelectIndustry: '請選擇所屬行業',
    pleaseEnterCompanyPassword: '請輸入企業密令',
    uploading: '正在上傳',
    uploadSuccess: '上傳成功',
    saveSuccess: '保存成功',

    // 预约管理相关
    publishProduct: '發佈商品',
    pleaseSelect: '請選擇',
    all: '全部',
    query: '查詢',
    productId: '產品ID',
    productName: '產品名稱',
    category: '分類',
    price: '價格',
    orderTime: '下單時間',
    appointmentTime: '預約時間',
    operation: '操作',
    edit: '編輯',
    delete: '刪除',
    confirmDeleteProduct: '確定刪除該商品？',
    sort: '排序',
    userName: '用戶姓名',
    appointmentPhone: '預約電話',
    remark: '備註',
    status: '狀態',
    cancelAppointment: '取消預約',
    confirmAppointment: '確認預約',
    newCategory: '新建分類',
    categoryName: '分類名稱',
    pleaseEnterCategoryName: '請輸入分類名稱',
    categoryId: '分類ID',
    productCount: '商品數量',
    addCategory: '新增分類',
    editCategory: '編輯分類',
    deleteCategory: '刪除分類',
    confirmDeleteCategory: '此操作將永久刪除該分類, 是否繼續?',
    operationSuccess: '操作成功',
    cancelInput: '取消輸入',
    selectProductCategory: '1.選擇產品分類',
    productCategory: '產品分類',
    inputProductBasicInfo: '2.輸入產品基本信息',
    productTitle: '產品標題',
    pleaseEnterContent: '請輸入內容',
    productPrice: '產品價格',
    specificAmount: '具體金額',
    rangeAmount: '區間金額',
    suchAs: '如：',
    productDescription: '產品簡述',
    productImage: '商品圖片',
    uploadImageTip: '上傳圖片的最佳尺寸：800像素*800像素，其他尺寸會影響頁效果，格式png，jpeg，jpg。大小不超過2M，商品圖片一共可以上傳5張，默認第一張為主圖封面',
    shareImage: '分享圖片',
    shareImageTip: '上傳圖片及支持png/jpg 。顯示圖片長寬比為5:4',
    shareImageUsage: '用於小程序分享時展示圖片',
    serviceMethod: '3.服務方式',
    serviceType: '服務方式',
    inStore: '到店',
    doorToDoor: '上門',
    inputProductDetails: '4.輸入產品詳情',
    publish: '發佈',
    pleaseSelectCategory: '請選擇分類！',
    pleaseEnterProductTitle: '請輸入產品標題！',
    pleaseEnterSpecificAmount: '請輸入具體金額',
    pleaseEnterRangeAmount: '請輸入區間金額!',
    pleaseEnterDescription: '請輸入描述',
    pleaseUploadProductImage: '請上傳商品圖片',
    pleaseUploadShareImage: '請上傳分享圖片',
    pleaseSelectServiceMethod: '請選擇服務方式！',
    uploading: '正在上傳',
    uploadSuccess: '上傳成功',
    pleaseEnterCancelReason: '請輸入取消理由',
    prompt: '提示',
    confirm: '確定',
    cancel: '取消',
    confirmAcceptAppointment: '確定接受此次預約麼?',
    operationSuccessExclamation: '操作成功！',
    pleaseEnterCancelReason: '請輸入取消理由',
    selectDate: '選擇日期',
    pendingConfirmation: '待確認',
    confirmed: '已確認',
    completed: '已完成',
    cancelled: '已取消',
    expired: '已過期',
    
    // 客户管理相关
    moveToMember: '移至成員',
    moveToShared: '移至共享',
    pleaseEnterPhoneNameWechat: '請輸入電話、姓名或微信號',
    search: '查詢',
    export: '導出',
    serialNumber: '序號',
    name: '姓名',
    phoneNumber: '手機號碼',
    wechatAccount: '微信號',
    createTime: '創建時間',
    remarks: '備註',
    transfer: '移交',
    details: '詳情',
    customerWechatData: '客戶企微數據',
    contactCustomerStatistics: '聯繫客戶統計',
    chatDataAnalysis: '聊天數據分析',
    moveToMemberTitle: '移至成員',
    moveToSharedTitle: '移至共享',
    pleaseSelectTransferMember: '請先選擇移交的成員',
    transferSuccess: '移交成功',
    moveToSharedConfirm: '此操作會將客戶移至共享池',
    prompt: '提示',
    confirm: '確定',
    cancel: '取消',
    warning: '警告',
    
    // 日期相關
    startDate: '開始日期',
    endDate: '結束日期',
    yesterday: '昨日',
    last7Days: '近七日',
    last30Days: '近30日',
    
    // 企微聊天統計相關
    customerWechatChatStatistics: '與客戶企微聊天統計',
    maxQuerySpan30Days: '支持的最大查詢跨度為30天',
    maxQuerySpan180Days: '最多可獲取最近180天內的數據',
    
    // 企微數據統計項
    newApplyCount: '發起申請數',
    newApplyCountDesc: '成員通過「搜索手機號」、「掃一掃」、「從微信好友中添加」、「從群聊中添加」、「添加共享、分配給我的客戶」、「添加單向、雙向刪除好友關係的好友」、「從新的聯繫人推薦中添加」等渠道主動向客戶發起的好友申請數量',
    newContactCount: '新增客戶數',
    newContactCountDesc: '新添加的客戶數量',
    chatCount: '聊天總數',
    chatCountDesc: '主動發送過消息的單聊總數',
    messageCount: '發送消息數',
    messageCountDesc: '單聊中發送的消息總數',
    replyPercentage: '已回覆聊天佔比',
    replyPercentageDesc: '客戶主動發起聊天後，成員在一個自然日內有回覆過消息的聊天數/客戶主動發起的聊天數比例，不包括群聊，僅在確有聊天時返回',
    avgReplyTime: '平均首次回覆時長',
    avgReplyTimeDesc: '單位為分鐘，即客戶主動發起聊天後，成員在一個自然日內首次回覆的時長間隔為首次回覆時長，所有聊天的首次回覆總時長/已回覆的聊天總數即為平均首次回覆時長，不包括群聊，僅在確有聊天時返回',
    negativeFeedbackCount: '刪除/拉黑成員的客戶數',
    negativeFeedbackCountDesc: '將成員刪除或加入黑名單的客戶數',
    
    // 預約管理標籤頁
    appointmentList: '預約列表',
    goodsList: '商品列表',
    productCategory: '產品分類',
    
    // 表單詳情相關
    pleaseSelect: '請選擇',
    startDate: '開始日期',
    endDate: '結束日期',
    to: '至',
    query: '查詢',
    export: '導出',
    serialNumber: '序號',
    userName: '用戶名',
    createTime: '創建時間',
    all: '全部',
    userFeedback: '用戶反饋',
    
    // 成員詳情相關
    basicInfo: '基本信息',
    name: '姓名',
    phoneNumber: '手機號碼',
    wechatAccount: '微信號',
    position: '職位',
    exclusiveCustomerCount: '獨佔客戶數',
    dealCustomerCount: '成單客戶數',
    wechatCustomerCount: '企微客戶數',
    operation: '操作',
    delete: '刪除',
    exclusiveCustomer: '獨佔客戶',
    dealCustomer: '成單客戶',
    wechatCustomer: '企微客戶',
    deleteMemberConfirm: '是否刪除該成員?',
    prompt: '提示',
    confirm: '確定',
    cancel: '取消',
    deleteSuccess: '刪除成功',
    deleteFailed: '刪除失敗',
    selectName: "请选择",
    noDepartment: "無部門",
    goToSettings: '去設置',
    addDepartment: '新增部門',

    // 部门设置
    sectorSetup: '部门设置',
    departmentName: '部门名称',
    administrator: '管理员',
    departmentMemberCount: '部门人数',
    authorizedMembers: '已授权成员',
    pendingAuthorizedMembers: '待授权成员数',
    operation: '操作',
    edit: '编辑',
    dissolve: '解散',
    searchDepartment: '请输入部门名称/管理员姓名',
    search: '搜索',
    importQywxStructure: '导入企微组织架构',
    viewAll: '查看所有',
    viewAllMembers: '查看所有成员',
    totalMembers: '共 {count} 位成员',
    departmentMemberList: '部门成员列表',
    departmentAdministrator: '部门管理员',
    modify: '修改',
    add: '新增',
    departmentEmployeeList: '部门员工列表',
    selectAll: '全选',
    addMember: '新增',
    remove: '移除',
    save: '保存',
    administratorList: '管理员列表',
    searchAdministrator: '请输入管理员姓名',
    noAdministrator: '暂无管理员',
    confirm: '确认',
    memberList: '成员列表',
    searchMember: '请输入成员姓名',
    importQywxStructureTitle: '导入企业微信组织架构',
    qywxInfoNotFilled: '未填写企微信息的账号并授权好，系统将无法导入。',
    goToFill: '去填写',
    goToAuthorize: '去授权',
    importWarning: '导入企业微信组织架构后，原组织架构将会被替代，所有原部门数据将会被清除，请慎重操作。',
    cancel: '取消',
    importConfirm: '确认',
    pleaseEnterDepartmentName: '请输入部门名称',
    addSuccess: '添加成功',
    operationCancelled: '操作取消',
    confirmDissolve: '是否确认解散该分组，解散后不可恢复。',
    tip: '提示',
    saveSuccess: '保存成功',
    pleaseAuthorizeQywx: '请先授权企业微信',
    operationSuccess: '操作成功',
    operationFailed: '操作失败，请稍后重试',
    pleaseSelectAdministrator: '请选择管理员',

    // 考核詳情相關
    assessmentRuleName: '考核規則名稱',
    assessmentTimeCycle: '考核時間週期',
    assessmentStatus: '考核狀態',
    assessmentContent: '考核內容',
    assessmentPassRate: '考核達標率',
    assessmentSituation: '考核情況',
    assessmentSituationTip: '可通過輸入或選擇考核對象名稱查看相應成員的考核詳情。',
    addCustomerCount: '添加客戶數',
    newUserVisitCount: '新用戶訪問數',
    customerFollowUpRate: '客戶跟進率',
    mallSalesAmount: '商城銷售金額',
    unit: '個',
    yuan: '港元',
    percent: '%',
    percentage: '%',
    inProgress: '進行中',
    notStarted: '未開始',
    ended: '已結束',
    pleaseSelectEmployee: '請選擇員工',
    search: '搜索',
    note: '注：默認只展示排名前三位員工的數據，其他成員請搜索查詢',
    completed: '已完成',
    selectRules: '選擇規則',
    noData: '暫無數據',
    selectAll: '全選',
    pleaseSelectDepartment: '請選擇部門',
    pleaseSelectDepartmentFirst: '請先選擇部門',
    pleaseEnterEmployeeName: '請輸入員工姓名',
    newUserVisitorCount: '新用戶訪問數',
    
    // 微信客戶端相關
    customerWechatData: '客戶企微數據',
    wechatChatStatistics: '與客戶企微聊天統計',
    singleChatTotal: '單聊總數',
    sendMessageCount: '發送消息數',
    sendRedPacketCount: '發送紅包數',
    sendRedPacketAmount: '發送紅包金額',
    repliedChatPercentage: '已回覆聊天佔比',
    averageFirstReplyTime: '平均首次回覆時長',
    mallOrder: '商城訂單',
    enterprise: '企業',
    description: '描述',
    source: '來源',
    warning: '警告',
    pleaseSelectTransferMember: '請先選擇移交的成員',
    transferSuccess: '移交成功',
    moveToMemberTitle: '移至成員',
    formTitle: "表單標題",
    formContent: "表單內容",
    title: "標題",
    isRequired: "是否必填",
    content: "內容",
    on: "是",
    off: "否",
    add: "新增",
    addSingle: "增加單行",
    singleOption: "單行選項",
    multipleOption: "多行選項",
    dropdownOption: "下拉選項",
    textBox: "文本框",
    rating: "評分",
    imageUpload: "圖片上傳",
    addressLocation: "地址定位",
    personalInfo: "個人信息",
    dateSelection: "日期選擇",
    addSingleRating: "增加單行評分",
    addSingleDropdown: "增加單行下拉",
    addSingleText: "增加單行文本",
    pleaseEnterText: "請輸入文本",
    clickToUploadImage: "點擊上傳圖片",
    image: "圖片",
    addSingleTitleContent: "增加單行標題和內容",
    selectStartDate: "選擇開始日期",
    selectEndDate: "選擇結束日期",
    pleaseEnterTitle: "請輸入標題",
    
    // 管理员列表相关
    searchAdministratorName: '搜索管理员姓名',
    addAdministrator: '新增管理员',
    changeBoss: '更换BOSS',
    responsibleDepartment: '负责部门',
    permissions: '权限',
    clickToView: '点击查看',
    viewPermissions: '查看权限',
    identityVerification: '身份验证',
    verify: '验证',
    employeeList: '员工列表',
    searchEmployeeName: '搜索员工姓名',
    noEmployees: '暂无员工',
    noPermissionsAssigned: '暂无权限分配',
    deleteConfirm: '确定删除该管理员？',
    changeBossConfirm: '确定更换BOSS吗？',
    selectEmployee: '请选择员工',
    changeSuccess: '更换成功',
    tip: '提示',
    noPermissionsSelected: '暂无权限选择',
    permissionsSelected: '已選擇權限',

    addEmployee: '新增員工',
    employeeName: '員工姓名',
    employeeEmail: '員工郵箱',
    employeePhone: '員工電話',
    departmentName: '部門名稱',
    pleaseEnterEmployeeName: '請輸入員工姓名',
    pleaseEnterEmployeeEmail: '請輸入員工郵箱',
    pleaseEnterEmployeePhone: '請輸入員工電話',
    pleaseEnterDepartmentName: '請輸入部門名稱',
    pleaseEnterPosition: '請輸入職位',
    pleaseEnterValidEmail: '請輸入有效的郵箱地址',
    addEmployeeSuccess: '新增員工成功',
    addEmployeeFailed: '新增員工失敗',
  },

  'en': {
    // 企业管理
    enterpriseMember: 'Enterprise Member',
    memberDetail: 'Member Detail',
    administratorList: 'Administrator List',
    sectorSetup: 'Sector Setup',
    setBanner: 'Set Banner',
    assessmentDetails: 'Assessment Details',
    inspectionRules: 'Inspection Rules',
    websiteSettings: 'Website Settings',
    formDetail: 'Form Detail',
    performanceAssessment: 'Performance Assessment',
    publishAdvancedForm: 'Publish Advanced Form',
    corporateInformation: 'Corporate Information',
    appointmentManagement: 'Appointment Management',
    advancedForm: 'Advanced Form',
    advertisingManagement: 'Advertising Management',
    wechatClient: 'WeChat Client',
    
    // 成员管理
    memberName: 'Member Name',
    memberPhone: 'Member Phone',
    memberEmail: 'Member Email',
    memberRole: 'Member Role',
    memberStatus: 'Member Status',
    joinDate: 'Join Date',
    department: 'Department',
    position: 'Position',
    jobNumber: 'Job Number',
    createTime: 'Create Time',
    loginAccount: 'Login Account',
    
    // 设置流程说明
    setupProcess: 'Department and Administrator Setup Process: ①First select the corresponding employee in the member list below, click "Edit", set as administrator------②In "Department Setup", add department, select corresponding administrator------③If you need to set administrator permissions, you can edit and modify administrator permissions in "Administrator List"',
    
    // 编辑成员对话框
    editMember: 'Edit Member',
    name: 'Name',
    displayPhone: 'Display Phone Number',
    displayEmail: 'Display Email',
    loginEmail: 'Login Email',
    setMemberRole: 'Set Member Role',
    normalMember: 'Normal Member',
    administrator: 'Administrator',
    pleaseSelect: 'Please Select',
    
    // 企业微信授权
    wechatAuth: 'WeChat Enterprise Authorization',
    wechatAuthTip: 'Please use the WeChat Enterprise super administrator account with the same WeChat subject as the BOSS account to scan the code for authorization.',
    wechatAuthNote: 'Note: Only after BOSS authorization, members under the enterprise can authorize.',
    wechatAuthorized: 'WeChat Enterprise Authorized',
    
    // 权限相关消息
    noPermission: 'No Permission',
    bossInfoCannotModify: 'BOSS information cannot be modified',
    
    // 角色类型
    employee: 'Employee',
    administrator: 'Administrator',
    boss: 'BOSS',
    
    // 考核管理
    assessmentName: 'Assessment Name',
    assessmentType: 'Assessment Type',
    assessmentDate: 'Assessment Date',
    assessmentScore: 'Assessment Score',
    assessmentResult: 'Assessment Result',
    assessmentRemark: 'Assessment Remark',
    
    // 成员考核页面
    assessmentRules: 'Assessment Rules',
    assessmentObject: 'Assessment Object',
    assessmentContent: 'Assessment Content',
    assessmentTimeCycle: 'Assessment Time Cycle',
    assessmentStatus: 'Status',
    assessmentPassRate: 'Assessment Pass Rate',
    assessmentOperation: 'Operation',
    assessmentDetail: 'Detail',
    assessmentRevoke: 'Revoke',
    assessmentAdd: 'Add Assessment Rule',
    assessmentEdit: 'Edit',
    assessmentQuery: 'Query',
    assessmentAll: 'All',
    assessmentNotStarted: 'Not Started',
    assessmentInProgress: 'In Progress',
    assessmentEnded: 'Ended',
    assessmentConfirmRevoke: 'Are you sure to revoke this assessment rule? It cannot be restored after deletion!',
    assessmentRevokeSuccess: 'Successfully revoked!',
    assessmentCancelInput: 'Cancel Input',
    assessmentRulesName: 'Assessment Rule Name',
    assessmentRulesPlaceholder: 'Assessment Rule/Assessment Object Name',
    assessmentStatusPlaceholder: 'Please Select Status',
    assessmentStartDate: 'Start Date',
    assessmentEndDate: 'End Date',
    assessmentAddCustomer: 'Add Customer Count',
    assessmentNewVisitors: 'New User Visitor Count',
    assessmentFollowUpRate: 'Follow-up Customer Rate',
    assessmentSalesAmount: 'Mall Sales Amount',
    assessmentPeople: 'People',
    
    // 表单管理
    formName: 'Form Name',
    formType: 'Form Type',
    formStatus: 'Form Status',
    createForm: 'Create Form',
    editForm: 'Edit Form',
    publishForm: 'Publish Form',
    formTemplate: 'Form Template',
    
    // 高级表单页面
    formList: 'Form List',
    basicSettings: 'Basic Settings',
    publishForm: 'Publish Form',
    query: 'Query',
    startDate: 'Start Date',
    endDate: 'End Date',
    publishTime: 'Publish Time',
    endTime: 'End Time',
    feedbackCount: 'Feedback Count',
    operation: 'Operation',
    feedbackDetail: 'Feedback Detail',
    edit: 'Edit',
    online: 'Online',
    offline: 'Offline',
    formModuleName: 'Form Module Name',
    formIntroduction: 'Form Introduction',
    buttonName: 'Button Name',
    contactUs: 'Contact Us',
    submitFeedback: 'Submit Feedback',
    feedbackPlaceholder: 'If you have better suggestions or opinions for us, you can click below to submit feedback and provide your valuable suggestions. Thank you for your support, we will contact you as soon as we receive it!',
    saveSettings: 'Save Settings',
    completeSettings: 'Please complete the basic settings',
    saveSuccess: 'Save Success',
    saveFailed: 'Save Failed',
    noPermission: 'No Permission',
    operationSuccess: 'Operation Success!',
    cancelInput: 'Cancel Input',
    cancelReason: 'Please enter cancellation reason',
    confirm: 'Confirm',
    cancel: 'Cancel',
    publishFormConfirm: 'This form will be published as a new form, and its user history will not follow.',
    offlineFormConfirm: 'Click to take this form offline and show the end time. And the "Advanced Form" page on the user side will show no content?',
    
    // 广告图管理页面
    imagePosition: 'Image Position',
    imageCount: 'Image Count',
    mallSection: 'Mall Section',
    appointmentSection: 'Appointment Section',
    dynamicSection: 'Dynamic Section',
    selectAuditDemand: 'Please select audit demand',
    uploadTip: 'Best image size: 690*300 pixels. Other sizes may affect page display. Formats: png, jpeg, jpg. Size limit: 2M. Minimum 1 image, maximum 6 images.',
    save: 'Save',
    uploading: 'Uploading...',
    uploadSuccess: 'Upload Successful',
    uploadFailed: 'Upload failed, please try again',
    settingSuccess: 'Setting Successful',
    categorySortTip: 'Please enter sort number, smaller number means higher priority',
    
    // 企业信息管理
    companyLogo: 'Company Logo',
    companyName: 'Company Name',
    industry: 'Industry',
    companyPassword: 'Company Password',
    companyNotice: 'Company Notice',
    uploadImage: 'Upload Image',
    pleaseEnter: 'Please Enter',
    pleaseSelect: 'Please Select',
    passwordPlaceholder: 'Password required for others to join company',
    pleaseUploadLogo: 'Please upload logo',
    pleaseEnterCompanyName: 'Please enter company name',
    pleaseSelectIndustry: 'Please select industry',
    pleaseEnterCompanyPassword: 'Please enter company password',
    uploading: 'Uploading',
    uploadSuccess: 'Upload Success',
    saveSuccess: 'Save Success',

    // 预约管理相关
    publishProduct: 'Publish Product',
    pleaseSelect: 'Please Select',
    all: 'All',
    query: 'Query',
    productId: 'Product ID',
    productName: 'Product Name',
    category: 'Category',
    price: 'Price',
    orderTime: 'Order Time',
    appointmentTime: 'Appointment Time',
    operation: 'Operation',
    edit: 'Edit',
    delete: 'Delete',
    confirmDeleteProduct: 'Are you sure you want to delete this product?',
    sort: 'Sort',
    userName: 'User Name',
    appointmentPhone: 'Appointment Phone',
    remark: 'Remark',
    status: 'Status',
    cancelAppointment: 'Cancel Appointment',
    confirmAppointment: 'Confirm Appointment',
    newCategory: 'New Category',
    categoryName: 'Category Name',
    pleaseEnterCategoryName: 'Please enter category name',
    categoryId: 'Category ID',
    productCount: 'Product Count',
    addCategory: 'Add Category',
    editCategory: 'Edit Category',
    deleteCategory: 'Delete Category',
    confirmDeleteCategory: 'This operation will permanently delete the category. Do you want to continue?',
    operationSuccess: 'Operation Successful',
    cancelInput: 'Cancel Input',
    selectProductCategory: '1. Select Product Category',
    productCategory: 'Product Category',
    inputProductBasicInfo: '2. Enter Basic Product Information',
    productTitle: 'Product Title',
    pleaseEnterContent: 'Please enter content',
    productPrice: 'Product Price',
    specificAmount: 'Specific Amount',
    rangeAmount: 'Range Amount',
    suchAs: 'e.g.,',
    productDescription: 'Product Description',
    productImage: 'Product Image',
    uploadImageTip: 'Optimal image size for upload: 800px*800px. Other sizes may affect page display. Formats: png, jpeg, jpg. Max size: 2MB. You can upload up to 5 product images, with the first image set as the main cover by default.',
    shareImage: 'Share Image',
    shareImageTip: 'Upload images in png/jpg format. Display aspect ratio is 5:4.',
    shareImageUsage: 'Used for displaying images when sharing on Mini Programs.',
    serviceMethod: '3. Service Method',
    serviceType: 'Service Type',
    inStore: 'In-Store',
    doorToDoor: 'Door-to-Door',
    inputProductDetails: '4. Enter Product Details',
    publish: 'Publish',
    pleaseSelectCategory: 'Please select a category!',
    pleaseEnterProductTitle: 'Please enter a product title!',
    pleaseEnterSpecificAmount: 'Please enter a specific amount',
    pleaseEnterRangeAmount: 'Please enter a range amount!',
    pleaseEnterDescription: 'Please enter a description',
    pleaseUploadProductImage: 'Please upload product images',
    pleaseUploadShareImage: 'Please upload a share image',
    pleaseSelectServiceMethod: 'Please select a service method!',
    uploading: 'Uploading',
    uploadSuccess: 'Upload Successful',
    pleaseEnterCancelReason: 'Please enter a cancellation reason',
    prompt: 'Prompt',
    confirm: 'Confirm',
    cancel: 'Cancel',
    confirmAcceptAppointment: 'Are you sure you want to accept this appointment?',
    operationSuccessExclamation: 'Operation Successful!',
    selectDate: 'Select Date',
    pendingConfirmation: 'Pending Confirmation',
    confirmed: 'Confirmed',
    completed: 'Completed',
    cancelled: 'Cancelled',
    expired: 'Expired',
    
    // Customer Management Related
    moveToMember: 'Move to Member',
    moveToShared: 'Move to Shared',
    pleaseEnterPhoneNameWechat: 'Please enter phone, name or WeChat ID',
    search: 'Search',
    export: 'Export',
    serialNumber: 'Serial Number',
    name: 'Name',
    phoneNumber: 'Phone Number',
    wechatAccount: 'WeChat Account',
    createTime: 'Create Time',
    remarks: 'Remarks',
    transfer: 'Transfer',
    details: 'Details',
    customerWechatData: 'Customer WeChat Data',
    contactCustomerStatistics: 'Contact Customer Statistics',
    chatDataAnalysis: 'Chat Data Analysis',
    moveToMemberTitle: 'Move to Member',
    moveToSharedTitle: 'Move to Shared',
    pleaseSelectTransferMember: 'Please select transfer member first',
    transferSuccess: 'Transfer successful',
    moveToSharedConfirm: 'This operation will move the customer to the shared pool',
    prompt: 'Prompt',
    confirm: 'Confirm',
    cancel: 'Cancel',
    warning: 'Warning',
    
    // Date Related
    startDate: 'Start Date',
    endDate: 'End Date',
    yesterday: 'Yesterday',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    
    // WeChat Chat Statistics Related
    customerWechatChatStatistics: 'Customer WeChat Chat Statistics',
    maxQuerySpan30Days: 'Maximum query span supported is 30 days',
    maxQuerySpan180Days: 'Maximum data available for the last 180 days',
    
    // WeChat Data Statistics Items
    newApplyCount: 'New Application Count',
    newApplyCountDesc: 'Number of friend applications actively initiated by members to customers through channels such as "Search by phone number", "Scan QR code", "Add from WeChat friends", "Add from group chat", "Add shared customers assigned to me", "Add friends with one-way or two-way deleted friend relationships", "Add from new contact recommendations", etc.',
    newContactCount: 'New Customer Count',
    newContactCountDesc: 'Number of newly added customers',
    chatCount: 'Total Chat Count',
    chatCountDesc: 'Total number of single chats where messages were actively sent',
    messageCount: 'Message Count',
    messageCountDesc: 'Total number of messages sent in single chats',
    replyPercentage: 'Replied Chat Percentage',
    replyPercentageDesc: 'Ratio of chats where members replied within one natural day after customers actively initiated chats / Total number of chats actively initiated by customers. Excludes group chats, only returned when there are actual chats.',
    avgReplyTime: 'Average First Reply Time',
    avgReplyTimeDesc: 'Unit is minutes. Time interval from when customers actively initiate chats to when members first reply within one natural day is the first reply time. Total first reply time of all chats / Total number of replied chats equals the average first reply time. Excludes group chats, only returned when there are actual chats.',
    negativeFeedbackCount: 'Customers Who Deleted/Blocked Members',
    negativeFeedbackCountDesc: 'Number of customers who deleted or blacklisted members',
    
    // Appointment Management Tabs
    appointmentList: 'Appointment List',
    goodsList: 'Goods List',
    productCategory: 'Product Category',
    
    // Form Detail Related
    pleaseSelect: 'Please Select',
    startDate: 'Start Date',
    endDate: 'End Date',
    to: 'to',
    query: 'Query',
    export: 'Export',
    serialNumber: 'Serial Number',
    userName: 'User Name',
    createTime: 'Create Time',
    all: 'All',
    userFeedback: 'User Feedback',
    
    // Member Detail Related
    basicInfo: 'Basic Information',
    name: 'Name',
    phoneNumber: 'Phone Number',
    wechatAccount: 'WeChat Account',
    position: 'Position',
    exclusiveCustomerCount: 'Exclusive Customer Count',
    dealCustomerCount: 'Deal Customer Count',
    wechatCustomerCount: 'WeChat Customer Count',
    operation: 'Operation',
    delete: 'Delete',
    exclusiveCustomer: 'Exclusive Customer',
    dealCustomer: 'Deal Customer',
    wechatCustomer: 'WeChat Customer',
    deleteMemberConfirm: 'Are you sure you want to delete this member?',
    prompt: 'Prompt',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteSuccess: 'Delete successful',
    deleteFailed: 'Delete failed',
    selectName: "please select",
    noDepartment: "No Department",
    goToSettings: 'Go to Settings',
    addDepartment: 'Add Department',

    // Department Setup
    sectorSetup: 'Department Setup',
    departmentName: 'Department Name',
    administrator: 'Administrator',
    departmentMemberCount: 'Department Member Count',
    authorizedMembers: 'Authorized Members',
    pendingAuthorizedMembers: 'Pending Authorized Members',
    operation: 'Operation',
    edit: 'Edit',
    dissolve: 'Dissolve',
    searchDepartment: 'Please enter department name/administrator name',
    search: 'Search',
    importQywxStructure: 'Import Enterprise WeChat Structure',
    viewAll: 'View All',
    viewAllMembers: 'View All Members',
    totalMembers: 'Total {count} members',
    departmentMemberList: 'Department Member List',
    departmentAdministrator: 'Department Administrator',
    modify: 'Modify',
    add: 'Add',
    departmentEmployeeList: 'Department Employee List',
    selectAll: 'Select All',
    addMember: 'Add',
    remove: 'Remove',
    save: 'Save',
    administratorList: 'Administrator List',
    searchAdministrator: 'Please enter administrator name',
    noAdministrator: 'No Administrator',
    confirm: 'Confirm',
    memberList: 'Member List',
    searchMember: 'Please enter member name',
    importQywxStructureTitle: 'Import Enterprise WeChat Structure',
    qywxInfoNotFilled: 'Accounts without Enterprise WeChat information filled and authorized cannot be imported by the system.',
    goToFill: 'Go to Fill',
    goToAuthorize: 'Go to Authorize',
    importWarning: 'After importing the Enterprise WeChat structure, the original structure will be replaced and all original department data will be cleared. Please operate with caution.',
    cancel: 'Cancel',
    importConfirm: 'Confirm',
    pleaseEnterDepartmentName: 'Please enter department name',
    addSuccess: 'Added successfully',
    operationCancelled: 'Operation cancelled',
    confirmDissolve: 'Are you sure to dissolve this group? This action cannot be undone.',
    tip: 'Tip',
    saveSuccess: 'Saved successfully',
    pleaseAuthorizeQywx: 'Please authorize Enterprise WeChat first',
    operationSuccess: 'Operation successful',
    operationFailed: 'Operation failed, please try again later',
    pleaseSelectAdministrator: 'Please select administrator',
    
    // Assessment Detail Related
    assessmentRuleName: 'Assessment Rule Name',
    assessmentTimeCycle: 'Assessment Time Cycle',
    assessmentStatus: 'Assessment Status',
    assessmentContent: 'Assessment Content',
    assessmentPassRate: 'Assessment Pass Rate',
    assessmentSituation: 'Assessment Situation',
    assessmentSituationTip: 'You can view the assessment details of corresponding members by entering or selecting the assessment object name.',
    addCustomerCount: 'Add Customer Count',
    newUserVisitCount: 'New User Visit Count',
    customerFollowUpRate: 'Customer Follow-up Rate',
    mallSalesAmount: 'Mall Sales Amount',
    unit: 'units',
    percent: '%',
    inProgress: 'In Progress',
    notStarted: 'Not Started',
    ended: 'Ended',
    pleaseSelectEmployee: 'Please select employee',
    search: 'Search',
    note: 'Note: By default, only the data of the top three employees are displayed. Other members please search and query.',
    completed: 'Completed',
    
    // WeChat Client Related
    customerWechatData: 'Customer WeChat Data',
    wechatChatStatistics: 'WeChat Chat Statistics with Customers',
    singleChatTotal: 'Single Chat Total',
    sendMessageCount: 'Send Message Count',
    sendRedPacketCount: 'Send Red Packet Count',
    sendRedPacketAmount: 'Send Red Packet Amount',
    repliedChatPercentage: 'Replied Chat Percentage',
    averageFirstReplyTime: 'Average First Reply Time',
    mallOrder: 'Mall Order',
    enterprise: 'Enterprise',
    description: 'Description',
    source: 'Source',
    warning: 'Warning',
    pleaseSelectTransferMember: 'Please select transfer member first',
    transferSuccess: 'Transfer successful',
    moveToMemberTitle: 'Move to Member',
    formTitle: "Form Title",
    formContent: "Form Content",
    title: "Title",
    isRequired: "Is Required",
    content: "Content",
    on: "On",
    off: "Off",
    add: "Add",
    addSingle: "Add Single",
    singleOption: "Single Option",
    multipleOption: "Multiple Option",
    dropdownOption: "Dropdown Option",
    textBox: "Text Box",
    rating: "Rating",
    imageUpload: "Image Upload",
    addressLocation: "Address Location",
    personalInfo: "Personal Info",
    dateSelection: "Date Selection",
    addSingleRating: "Add Single Rating",
    addSingleDropdown: "Add Single Dropdown",
    addSingleText: "Add Single Text",
    pleaseEnterText: "Please Enter Text",
    clickToUploadImage: "Click to Upload Image",
    image: "Image",
    addSingleTitleContent: "Add Single Title and Content",
    selectStartDate: "Select Start Date",
    selectEndDate: "Select End Date",
    pleaseEnterTitle: "Please Enter Title",
    
    // 管理员列表相关
    searchAdministratorName: 'Search Administrator Name',
    addAdministrator: 'Add Administrator',
    changeBoss: 'Change BOSS',
    responsibleDepartment: 'Responsible Department',
    permissions: 'Permissions',
    clickToView: 'Click to View',
    viewPermissions: 'View Permissions',
    identityVerification: 'Identity Verification',
    verify: 'Verify',
    employeeList: 'Employee List',
    searchEmployeeName: 'Search Employee Name',
    noEmployees: 'No Employees',
    noPermissionsAssigned: 'No Permissions Assigned',
    deleteConfirm: 'Confirm Delete Administrator?',
    changeBossConfirm: 'Confirm Change BOSS?',
    selectEmployee: 'Please Select Employee',
    changeSuccess: 'Change Successful',
    tip: 'Tip',
    noPermissionsSelected: 'No Permissions Selected',
    permissionsSelected: 'Permissions Selected',
    addEmployee: 'Add Employee',
    employeeName: 'Employee Name',
    employeeEmail: 'Employee Email',
    employeePhone: 'Employee Phone',
    departmentName: 'Department Name',
    pleaseEnterEmployeeName: 'Please enter employee name',
    pleaseEnterEmployeeEmail: 'Please enter employee email',
    pleaseEnterEmployeePhone: 'Please enter employee phone',
    pleaseEnterDepartmentName: 'Please enter department name',
    pleaseEnterPosition: 'Please enter position',
    pleaseEnterValidEmail: 'Please enter a valid email address',
    addEmployeeSuccess: 'Employee added successfully',
    addEmployeeFailed: 'Failed to add employee',
  }
}; 